import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_WORK_PASS_TYPES_URL } from '../../constants/apiUrls';
import { GET_WORK_PASS_TYPES_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface WorkPassType {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
export enum Type {
  parent = 'parent',
  candidate = 'candidate',
}

interface Input {
  onSuccess?: (data: WorkPassType[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
  type: Type;
}

export const useGetWorkPassTypes = ({ onSuccess, onError, enabled = true, type }: Input) => {
  const getWorkPassTypes = async () => {
    const res = await axiosClient.get<WorkPassType[]>(GET_WORK_PASS_TYPES_URL(type));
    return res.data;
  };

  return useCustomQuery(GET_WORK_PASS_TYPES_QUERY_KEY.concat(type), getWorkPassTypes, {
    onSuccess,
    onError,
    enabled,
    staleTime: 2000,
  });
};
